export default __webpack_public_path__ + "static/media/complex-layout-1.b086f5b8.png";